import { useEffect, useState } from 'react'
import { Tooltip, Typography } from '../components/generic.tsx'
import { I18n } from '../components/I18n.tsx'
import { Stack } from '../components/Stack.tsx'
import { usePreferences } from '../data/userProfile.ts'
import { type Dayjs, dayjs } from '../dayjs.ts'
import { ids } from '../ids.ts'
import { useFormatDate } from './preferences/useFormatDate.tsx'

export const Clock = () => {
	const { data: pref } = usePreferences()
	const format = useFormatDate()
	const [time, setTime] = useState(dayjs().tz(pref.timezone))
	const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

	useEffect(() => {
		const interval = setInterval(() => setTime(dayjs().tz(pref.timezone)), 1000)
		return () => clearInterval(interval)
	}, [pref.timezone])

	return (
		<Tooltip
			data-ta={ids.measurements.clock.root}
			placement='bottom-start'
			arrow
			title={
				<Stack col sx={{ p: 1 }}>
					<Typography data-ta={ids.measurements.clock.tooltip.userTime} variant='code1'>
						{format(time, 'DD.MM.HH.mm')}
						{time.format(' (UTCZ) — ')}
						{pref.timezone}
					</Typography>
					{!hasSameTimezone(time, dayjs().tz(systemTimeZone)) && (
						<Typography data-ta={ids.measurements.clock.tooltip.systemTime} variant='code1'>
							{format(time, 'DD.MM.HH.mm', systemTimeZone)}
							{time.tz(systemTimeZone).format(' (UTCZ) — ')}
							{<I18n i18nKey={($) => $.yourSystemTime} />}
						</Typography>
					)}
					<Typography data-ta={ids.measurements.clock.tooltip.utcTime} variant='code1'>
						{format(time, 'DD.MM.HH.mm', 'UTC')} (UTC)
					</Typography>
				</Stack>
			}
		>
			<Stack col spacing={0}>
				<Typography data-ta={ids.measurements.clock.time} variant='h3' sx={{ lineHeight: '1.2em' }}>
					{format(time, 'HH.mm')}
				</Typography>
				<Typography data-ta={ids.measurements.clock.timezone} variant='code2' sx={{ lineHeight: '1.2em' }}>
					UTC{time.format('Z')}
				</Typography>
			</Stack>
		</Tooltip>
	)
}

const hasSameTimezone = (t1: Dayjs, t2: Dayjs) => t1.utcOffset() === t2.utcOffset()
